export default __webpack_public_path__ + "static/tek_podcast-1290aa5aab7b16cf36359fefa79ac898.png";